/*
 * @Descripttion: 场景管理
 * @Date: 2026-07-24
 */
import { route } from './src/router';

const name = 'scene-mgmt';

export { name, route };
